import React from "react";
import DiaryBoard from "../../components/diary/DiaryBoard";
import { Navigate, Route, Routes } from "react-router-dom";
import AdminMenu from "./AdminMenu";
import Index from "./pages/Index";
import AdmissionProfile from "./pages/components/admission/AdmissionProfile";
import SwitchAdmission from "./pages/components/admission/SwitchAdmission";
import ViewAdmission from "./pages/components/admission/ViewOnlyPage";
import InstructorPage from "./pages/components/instructor/InstructorPage";
import SupportStaffPage from "./pages/components/supportstaff/SupportStaffPage";
import SwitchInstructor from "./pages/components/instructor/SwitchInstructor";
import SwitchAttendance from "./pages/components/manageattendance/SwitchAttendance";
import ClassMain from "./pages/components/manageclass/ClassMain";
import SwitchClass from "./pages/components/manageclass/SwitchClass";
import DepartmentMain from "./pages/components/managedepartment/DepartmentMain";
import AddEditFeeTemplate from "./pages/components/managefee/AddEditTemplate";
import SwitchFee from "./pages/components/managefee/SwitchFee";
import ViewStudentFee from "./pages/components/managefee/ViewStudentFee";
import SwitchForm from "./pages/components/manageform/SwitchForm";
import SwitchSchoolSettings from "./pages/components/manageschool/SwitchSchoolSettings";
import ManageMessage from "./pages/components/managemessage";
import HomeWork from "./pages/components/managemessage/HomeWork";
import StudentParentList from "./pages/components/manageparent/StudentParentList";
import ViewEditStudentDetails from "./pages/components/manageparent/ViewEditStudentDetails";

// import AddEditGenerate from "./pages/components/managereportcard/AddEditGenerate";
// import SwitchReportCard from "./pages/components/managereportcard/SwitchReportCard";
// import ViewEditProgressCard from "./pages/components/managereportcard/ViewEditProgressCard";
// import ViewTemplate from "./pages/components/managereportcard/ViewTemplate";
// import ViewTemplateHistory from "./pages/components/managereportcard/ViewTemplateHistory";

import SwitchSchedule from "./pages/components/manageschedule/SwitchSchedule";
import ManageAlarm from "./pages/components/managealarm/ManageAlarm";
import ManageStudentMain from "./pages/components/managestudent/ManageStudentMain";
import SwitchStudent from "./pages/components/managestudent/SwitchStudent";
import SubjectMain from "./pages/components/managesubject/SubjectMain";
import SwitchSubject from "./pages/components/managesubject/SwitchSubject";
import SwitchTransportation from "./pages/components/managetransportation/SwitchTransportation";
import ParentHomePage from "./pages/components/parent/ParentHomePage";
import HelpPage from "./pages/help/HelpPage";
import ManageAssignmentV2 from "./pages/components/manageassignment-v2/ManageAssignment";
import ManageExam from "./pages/components/manageexam/ManageExam";

import SwitchTabs from "./pages/components/instructorAttendance/SwitchTabs";
import InstructorReportStatus from "./pages/components/instructorAttendance/InstructorReportStatus";
import AdminLiveTracking from "./pages/Live tracking/SwitchTabs";
import SwitchClassAnnouncements from "./pages/components/managemessage/SwitchClassAnnouncements";
import SwitchWhatsApp from "./pages/components/managewhatsapp/SwitchWhatsApp";

import AddEditGenerate from "./pages/components/ProgressCard-V2/AddEditGenerate";
import SwitchReportCard from "./pages/components/ProgressCard-V2/SwitchReportCard";
import ViewEditProgressCard from "./pages/components/ProgressCard-V2/ViewEditProgressCard";
import ViewTemplate from "./pages/components/ProgressCard-V2/ViewReportTemplate";
import ViewTemplateHistory from "./pages/components/ProgressCard-V2/ViewTemplateHistory";
import SwitchExpense from "./pages/components/manageexpenses/SwitchExpense";
import SwitchPayroll from "./pages/components/managepayroll/SwitchPayroll";
import SwitchCertBuilder from "./pages/components/manageform/SwitchCertBuilder";
import Iskool360Dashboard from "./pages/components/dashboard360/Iskool360Dashboard";
import SwitchTrip from "./pages/components/managetrip/SwitchTrip";
import SwitchStock from "./pages/components/managestock/SwitchStock";
import AdminCourseBoard from "./pages/courseboard";
import SwitchCourseTab from "../instructor/pages/CourseBoard/SwitchCourseTab";

const url = "/dashboard";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="admin/menu" element={<AdminMenu />} />
      <Route path="admin/profile" element={<Index />} />
      <Route path="admin/menu/instructor" element={<InstructorPage />} />
      <Route path="admin/menu/support-staff" element={<SupportStaffPage />} />
      <Route path="admin/menu/instructor/profile/:id" element={<SwitchInstructor />} />
      <Route path="admin/menu/admission" element={<SwitchAdmission />} />
      <Route path="admin/menu/admission/:id" element={<AdmissionProfile />} />
      <Route path="admin/menu/admission/view/:id" element={<ViewAdmission />} />
      <Route path="admin/parent" element={<ParentHomePage />} />
      <Route path="admin/menu/student" element={<ManageStudentMain />} />
      <Route path="admin/menu/student/profile/:id" element={<SwitchStudent />} />
      <Route path="admin/menu/class" element={<ClassMain />} />
      <Route path="admin/menu/class/profile/:id" element={<SwitchClass />} />
      <Route path="admin/menu/subject" element={<SubjectMain />} />
      <Route path="admin/menu/subject/profile/:id" element={<SwitchSubject />} />
      <Route path="admin/menu/course-board" element={<AdminCourseBoard />} />
      {/* Reuses instructor's SwitchCourseTab unmodified — it already reads
          className/classId/subjectId from useParams() and has no role gate
          of its own; only Syllabus.js's write-gate needed to learn "admin". */}
      <Route
        path="admin/menu/course-board/:className/:classId/:subjectId"
        element={<SwitchCourseTab />}
      />
      <Route path="admin/menu/department" element={<DepartmentMain />} />
      <Route path="admin/menu/fee/:tab" element={<SwitchFee />} />
      <Route path="admin/menu/class/:id/student/:id" element={<ViewStudentFee />} />
      <Route path="admin/menu/fee/template/:id" element={<AddEditFeeTemplate />} />
      <Route path="admin/menu/attendance" element={<SwitchAttendance />} />
      <Route path="admin/menu/parent" element={<StudentParentList />} />
      <Route path="admin/menu/parent/:id" element={<ViewEditStudentDetails />} />
      <Route path="admin/menu/report/" element={<SwitchReportCard />} />
      <Route path="admin/menu/report-template/:id" element={<ViewTemplate />} />
      <Route path="admin/menu/student/:id/template/:id" element={<AddEditGenerate />} />
      <Route path="admin/menu/student/template-history/:id" element={<ViewTemplateHistory />} />
      <Route path="admin/menu/class-announcements" element={<SwitchClassAnnouncements />} />
      <Route path="admin/menu/whatsapp" element={<SwitchWhatsApp />} />
      <Route path="admin/menu/whatsapp/:tab" element={<SwitchWhatsApp />} />
      <Route path="admin/menu/instructor-attendance" element={<SwitchTabs />} />
      <Route path="admin/menu/instructor-attendance/report-status" element={<InstructorReportStatus />} />
      <Route path="admin/menu/student/:id/template/:id/report/:id/" element={<ViewEditProgressCard />} />
      <Route path="admin/menu/form" element={<SwitchForm />} />
      <Route path="admin/menu/home-work" element={<HomeWork />} />
      <Route path="admin/menu/diary" element={<DiaryBoard role="admin" mode="senior" />} />
      <Route path="admin/menu/message" element={<ManageMessage />} />
      <Route path="admin/menu/schedule/" element={<SwitchSchedule />} />
      <Route path="admin/menu/alarm" element={<ManageAlarm />} />
      <Route path="admin/menu/transportation/" element={<SwitchTransportation />} />
      <Route path="admin/menu/live-tracking/" element={<AdminLiveTracking />} />
      <Route path="admin/menu/assignment/" element={<ManageAssignmentV2 />} />
      <Route path="admin/menu/exam/" element={<ManageExam />} />
      <Route path="admin/menu/expenses" element={<SwitchExpense />} />
      <Route path="admin/menu/payroll" element={<SwitchPayroll />} />
      <Route path="admin/menu/consent-form/:tab" element={<SwitchTrip basePath="/dashboard/admin/menu/consent-form" />} />
      <Route path="admin/menu/stock" element={<SwitchStock />} />
      <Route path="admin/menu/certificate-builder" element={<SwitchCertBuilder />} />
      <Route path="admin/menu/school-settings" element={<SwitchSchoolSettings />} />
      <Route path="admin/help" element={<HelpPage />} />
      <Route path="admin/home" element={<Iskool360Dashboard />} />
      <Route index element={<Navigate to={`${url}/admin/home`} replace />} />
    </Routes>
  );
};

export default AdminRoutes;
